import styled from 'styled-components';

export const StyledBrandList = styled.div`
    position: relative;
    overflow: hidden;

    .brand-item-single {
        padding: 200px 0;
        background: #EFEFEF;
        position: relative;
        overflow: hidden;

        &:nth-of-type(even) {
            background: white;
        }

        .container {
            .row {
                padding-top: 40px;
                position: relative;
                &:after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    width: calc(100% - 30px);
                    margin: 0 auto;
                    height: 1px;
                    background: rgba(21, 38, 55, 0.50);
                }
            }
        }

        .brand-item-left {
            p {
                color: #152637;
                font-size: 1rem;
                font-style: normal;
                font-weight: 500;
                line-height: 1.5rem;
            }
            img {
                margin-top: 80px;
				@media(min-width: 1024px){
                    height: 200px;
                    width: 75%;
                    object-fit: contain;
				}
            }
        }

        .brand-item-right {
            h3 {
                margin-bottom: 40px;
                color: #152637;
                font-size: 2rem;
                font-style: normal;
                font-weight: 500;
                line-height: 2.25rem;
            }

            p {
                color: #152637;
                font-size: 1rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1.5rem;
                font-family: "PP Neue Montreal";
            }
        }
		.fixed-right{
			z-index: 1;
			position: absolute;
			right: 0;
			top: 0;
		}
        .fixed-left {
            z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
        }
        //&:nth-of-type(n+2){
        //    .fixed-left {
        //       display: none;
        //    }
		//}
        //&:nth-of-type(n+3) {
        //    .fixed-left {
        //        position: absolute;
        //        right: 0;
        //        top: 0;
        //        z-index: 1;
        //        left: unset;
		//		display: block !important;
        //    }
        //}

        @media (max-width: 767px) {
            padding: 100px 0;
            .brand-item-left {
                p {
                    color: #152637;
                    font-size: 1rem;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 1.5rem;
                }
                img {
                    margin-top: 40px;
                    margin-bottom: 40px;
                }
            }
        }
    }
`;
